import { Email, Name, Role, Success } from "../icons";
import "../styles/_summary.scss";
import type { SummaryProps } from "../types";
import { formatDate } from "../utils";

export const Summary = ({ name, email, role, timestamp }: SummaryProps) => (
  <div className="accept-summary-71d72f0d-8486-4d9d-b58c-a5b9facf4701">
    <div className="summary__wrapper">
      <div className="summary__icon">
        <Success />
      </div>
      <h3 className="summary__title">Accepted by:</h3>
      <div className="summary__name">{name}</div>
      <div className="summary__data">
        <div className="summary__row">
          <Name />
          <span>{name}</span>
        </div>
        <div className="summary__row">
          <Email />
          <span>{email}</span>
        </div>
        {role ? (
          <div className="summary__row">
            <Role />
            <span>{role}</span>
          </div>
        ) : null}
      </div>
      <p className="summary__date">Approved at {formatDate(timestamp)}</p>
    </div>
  </div>
);
